import { __assign } from "tslib";
import readingTime from 'reading-time';
import { getFeature } from '../../DaEditorWrapper/Features/helper';
import { FIRST_IMAGE_FEATURE, WORD_COUNT_FEATURE, MEDIA_COUNT_FEATURE, } from '../../DaEditorWrapper/Features';
import get from 'lodash/get';
import MediaService, { fallbackToLargestFile, } from '../../utils/DeviationMediaService';
import ddt from '@wix/da-ddt';
import { getDeviationType } from '../_helpers';
import { DeviationTypes } from '../../types/deviation';
function coverDeviationExists(source) {
    return !!source.deviation;
}
export var getCoverImageAttributes = function (source) {
    var preview = getCoverImageFile(source);
    if (!preview) {
        return;
    }
    var style = {
        backgroundImage: "url('".concat(preview.src, "')"),
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'center',
        backgroundPositionY: 'center',
        backgroundSize: 'cover',
    };
    return { style: style };
};
export function getCoverImageFile(source) {
    if (!coverDeviationExists(source)) {
        return;
    }
    if (source.deviation && source.deviation.coverImage) {
        return getCoverImageWithDraftJSType(source);
    }
    return get(source.deviation, 'textContent.html.type') === 'writer'
        ? getCoverImageWithWriterType(source)
        : getCoverImageWithDraftJSType(source);
}
function getDraftJSFirstImage(source) {
    // See if we have first image feature, newer journals wont have anything
    var firstImageFeature = getFeature(FIRST_IMAGE_FEATURE, get(source.deviation, 'textContent.html.features', []));
    var firstImage = get(firstImageFeature, 'data.deviation');
    firstImage &&
        ddt.log('journalcover', 'Journal using first image', source.deviation);
    return firstImage;
}
function getDraftJSCoverImage(_a) {
    // cover image can either be inside the coverImage property or
    // if it's not a text deviation it's the passed deviation itself
    var deviation = _a.deviation;
    var sourceCoverImage = deviation.coverImage, sourceTextContent = deviation.textContent;
    if (sourceCoverImage) {
        return sourceCoverImage;
    }
    if (!sourceTextContent) {
        return deviation;
    }
}
/**
 * DraftJS has two versions:
 * - Legacy first image was used in beta stages
 * - CoverImage was when we let users select the cover
 */
function getCoverImageWithDraftJSType(source) {
    var _a;
    // Prefer coverImage over firstImage
    var deviation = (_a = getDraftJSCoverImage(source)) !== null && _a !== void 0 ? _a : getDraftJSFirstImage(source);
    if (!deviation) {
        return;
    }
    // Finally we try and find a image that will cover the requested block size
    return getCoverImageForSource(__assign(__assign({}, source), { deviation: deviation }));
}
function getCoverImageWithWriterType(source) {
    var _a, _b, _c;
    if (getDeviationType(source.deviation) === DeviationTypes.STATUS) {
        var deviation = (_c = (_b = (_a = source.deviation.status) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.type === 'thumb_background_deviation'; })) === null || _c === void 0 ? void 0 : _c.deviation;
        return deviation
            ? getCoverImageForSource(__assign(__assign({}, source), { deviation: deviation }))
            : undefined;
    }
    return getCoverImageForSource(source);
}
function getCoverImageForSource(_a) {
    var deviation = _a.deviation, _b = _a.width, width = _b === void 0 ? 300 : _b, _c = _a.height, height = _c === void 0 ? 300 : _c, allowHuge = _a.allowHuge;
    if (deviation.isBlocked) {
        return;
    }
    return MediaService.getSmallestThumbThatFullyCovers(deviation, width, height, fallbackToLargestFile, {
        allowPreview: allowHuge,
        allowFullview: allowHuge,
    });
}
export var getReadingTimeMinutes = function (textContent) {
    if (!textContent) {
        return 0;
    }
    if (!isTextContentDraftJs(textContent)) {
        if (!textContent.html.markup) {
            return 0;
        }
        // Wrong but meh...
        return Math.ceil(readingTime(textContent.html.markup).minutes);
    }
    var counts = getFeature(WORD_COUNT_FEATURE, textContent.html.features);
    if (!counts) {
        return 0;
    }
    return Math.ceil(counts.data.words / 200);
};
export var isTextContentDraftJs = function (textContent) {
    return !!(textContent && textContent.html && textContent.html.type === 'draft');
};
export var textContentHasMedia = function (textContent) {
    if (!isTextContentDraftJs(textContent)) {
        return false;
    }
    var mediaCountFeature = getFeature(MEDIA_COUNT_FEATURE, textContent.html.features);
    var mediaCounts = get(mediaCountFeature, 'data', {});
    return mediaCounts && (mediaCounts['images'] > 0 || mediaCounts['video'] > 0);
};
export function getTranslationKeyForAccessibleDeviationLink(t, deviation) {
    var _a;
    var type = getDeviationType(deviation);
    var args = {
        title: deviation.title,
        author: (_a = deviation.author) === null || _a === void 0 ? void 0 : _a.username,
    };
    switch (type) {
        case DeviationTypes.IMAGE:
            return t('deviationview.a11y.link.visualArt', args);
        case DeviationTypes.JOURNAL:
            return t('deviationview.a11y.link.journal', args);
        case DeviationTypes.LITERATURE:
            return t('deviationview.a11y.link.literature', args);
        case DeviationTypes.FILM:
            return t('deviationview.a11y.link.film', args);
        case DeviationTypes.PDF:
            return t('deviationview.a11y.link.pdf', args);
        case DeviationTypes.POLL:
            return t('deviationview.a11y.link.poll', args);
        case DeviationTypes.COMMISSION:
            return t('deviationview.a11y.link.commission', args);
        case DeviationTypes.STATUS:
            return t('deviationview.a11y.link.status', args);
        case DeviationTypes.TIER:
            return t('deviationview.a11y.link.tier', args);
        case DeviationTypes.UNKNOWN:
        default:
            return t('deviationview.a11y.link.unknown', args);
    }
}
//# sourceMappingURL=helpers.js.map